import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { getTypographyStyles, variants } from './Typography.styles.js';

var _excluded = ["variant", "colour"];
var Typography = function Typography(_ref) {
  var variant = _ref.variant,
    _ref$colour = _ref.colour,
    colour = _ref$colour === void 0 ? 'primary' : _ref$colour,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = getTypographyStyles(variant);
  return React__default.createElement(Component, _extends({
    $colour: colour
  }, props));
};
Typography.propTypes = {
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  children: PropTypes.node.isRequired,
  colour: PropTypes.string,
  variant: PropTypes.oneOf(variants).isRequired
};

export { Typography };
//# sourceMappingURL=Typography.js.map
